angular.module('Waiteraid',['ngSanitize']);
